import moment from 'moment'

export default {
  regType: "HSIND",
  firstName: "",
  lastName: "",
  email: "",
  schoolId: "",
  needTranslator: "",
  specifiedLanguage: "",
  otherSchoolName: "",
  gradeLevelId: "",
  tShirtSizeId: "",
  hasAttended: 0,
  tourType: {
    aerospaceEngineering: 0,
    geosciences: 0,
    honorsCollege: 0,
    varsityESports: 0,
    stemInSports: 0,
    criminalJustice: 0,
    nursingSimulations: 0,
    chemicalTransformations: 0,
    engineeringDesign: 0
  },
  parentGuardian: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    willBeAttending: "",
    willAddParentBeAttending: "",
    addParentFirstName: "",
    addParentLastName: ""
  },
  emergencyContact: {
    firstName: "",
    lastName: "",
    phoneNumber: ""
  },
  consentWillBeSubmittedBySchool: "",
  stemDayConsent: {
    parentGuardianName: "",
    relation: "",
    studentName: "",
    parentGuardianElSignature: "",
    date: moment().format('MM/DD/YYYY')
  }
}